var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13697 13.147C7.42697 12.29 6.99097 11.2 6.99097 10C6.99097 7.24 9.23197 5 11.991 5C13.192 5 14.282 5.435 15.139 6.145L17.036 4.248C15.595 3.51 13.914 3 12.001 3C5.88597 3 1.97597 8.355 1.15897 9.584C1.68797 10.418 3.53797 13.111 6.27197 15.012L8.13697 13.147ZM14.431 6.853C13.758 6.323 12.916 6 11.991 6C9.78397 6 7.99097 7.792 7.99097 10C7.99097 10.923 8.31497 11.765 8.84497 12.439L14.431 6.853ZM21.991 0.707L2.69897 20L1.99097 19.293L5.53897 15.745C3.24097 14.133 1.30497 11.86 -0.0090332 9.576C2.40897 5.473 6.93397 2 12.001 2C14.066 2 16.022 2.566 17.783 3.501L21.284 0L21.991 0.707ZM19.526 4.586L18.792 5.32C21.028 6.939 22.42 8.924 22.853 9.594C22.114 10.897 18.307 17 12.001 17C10.576 17 9.25197 16.632 8.04997 16.062L7.30197 16.81C8.77697 17.552 10.359 18 12.001 18C17.275 18 21.759 13.994 24 9.564C22.913 7.673 21.37 5.927 19.526 4.586ZM15.991 10C15.991 9.446 15.878 8.918 15.674 8.438L16.408 7.704C16.769 8.394 16.991 9.168 16.991 10C16.991 12.759 14.751 15 11.991 15C11.159 15 10.387 14.777 9.69597 14.417L10.43 13.682C10.91 13.886 11.437 14 11.991 14C14.199 14 15.991 12.208 15.991 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eyeOff.2c592c8e.svg";
export { ForwardRef as ReactComponent };